import React from 'react'

interface FullPageContentProps {
  className?: string
  children?: React.ReactNode
  /** Infinite-scroll pages listen here — this is the element that actually scrolls. */
  onScroll?: React.UIEventHandler<HTMLDivElement>
}

/**
 * The page's single scroll container. It takes whatever height is left under the
 * page bar rather than measuring the viewport, so nothing can be sized taller
 * than the space it actually has and get clipped mid-card.
 */
export const FullPageContent = React.forwardRef<HTMLDivElement, FullPageContentProps>(
  ({ className, children, onScroll }, ref) => (
    <div
      ref={ref}
      onScroll={onScroll}
      className={`relative min-h-0 w-full flex-1 overflow-y-auto ${className ?? ''}`}
    >
      {children}
    </div>
  )
)
